import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { __ } from '@@/bits/intl'
import { windowHeight } from '@@/bits/browser'
import OzCenterModal from '@@/library/v4/components/OzCenterModal.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzLargeConfirmationDialog',
  props: {
    title: null,
    iconSrc: { default: null },
    iconAlt: { default: null },
    body: { default: undefined },
    confirmButtonText: { default: undefined },
    cancelButtonText: { default: undefined },
    shouldFadeIn: { type: Boolean, default: true }
  },
  emits: ['confirm', 'cancel'],
  setup(__props: any) {

const props = __props as { title: string, iconSrc: string | null, iconAlt: string | null, body: string, confirmButtonText: string, cancelButtonText: string, shouldFadeIn: boolean }



const buttons = computed(() => {
  return [
    {
      text: props.cancelButtonText || __('Cancel'),
      emit: 'cancel',
      colorScheme: OzContainedButtonColorScheme.Secondary,
      testId: 'cancelButton',
    },
    {
      text: props.confirmButtonText || __('Continue'),
      emit: 'confirm',
      colorScheme: OzContainedButtonColorScheme.Primary,
      testId: 'confirmButton',
    },
  ]
})



return { __sfc: true,props, buttons, windowHeight, OzCenterModal, OzContainedButton }
}

})